import { BoltIcon, BriefcaseIcon, ClockIcon } from "@heroicons/react/24/solid";

export const listReasonsTax = [
  {
    icon : () => {return (<BriefcaseIcon className="w-full"/>)},
    slug : "tax_reason_slug_1",
    title: "tax_reason_title_1",
    description: "tax_reason_description_1"
  },
  {
    icon : () => {return (<BoltIcon className="w-full"/>)},
    slug : "tax_reason_slug_2",
    title: "tax_reason_title_2",
    description: "tax_reason_description_2"
  },
  {
    icon : () => {return (<ClockIcon className="w-full"/>)},
    slug : "tax_reason_slug_3",
    title: "tax_reason_title_3",
    description: "tax_reason_description_3"
  }
]